import { render, staticRenderFns } from "./Macros.vue?vue&type=template&id=515a1982&scoped=true"
import script from "./Macros.vue?vue&type=script&lang=js"
export * from "./Macros.vue?vue&type=script&lang=js"
import style0 from "./Macros.vue?vue&type=style&index=0&id=515a1982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a1982",
  null
  
)

export default component.exports